"use client";

import { c as _c } from "react/compiler-runtime";
import HospitalResultCardContent, { type HospitalResultCardContentProps } from "@/shared/ui/molecules/HospitalResultCardContent";
export type HospitalResultCardProps = HospitalResultCardContentProps;
const HospitalResultCard = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <div className="flex min-w-0 w-full rounded-lg bg-white"><div className="flex min-w-0 flex-1 items-center gap-2 py-3.5 pl-3.5 pr-3.5"><HospitalResultCardContent {...props} /></div></div>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default HospitalResultCard;